"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const react_1 = require("@headlessui/react");
const js_1 = require("@mdi/js");
const class_variance_authority_1 = require("class-variance-authority");
const react_2 = __importDefault(require("react"));
const icon_1 = require("./icon");
const InputVariants = (0, class_variance_authority_1.cva)([
    "ko:w-full",
    "ko:border ko:border-neutral",
    "ko:rounded-2xl ko:rounded-br-none",
    "ko:placeholder:text-base ko:placeholder:font-sans ko:placeholder:text-neutral",
    "ko:data-hover:border-neutral-hover",
    "ko:data-disabled:placeholder:text-neutral-disabled ko:data-disabled:border-neutral-disabled ko:data-disabled:text-neutral-disabled",
    "ko:[&::-webkit-search-cancel-button]:hidden",
], {
    variants: {
        variant: {
            default: "ko:p-4",
            icon: "ko:p-4 ko:pl-14",
        },
        clearable: {
            true: "ko:pr-14",
            false: "",
        },
    },
});
function InputComponent({ children, variant, onClear, clearLabel, ...props }, ref) {
    const inputRef = react_2.default.useRef(null);
    const hasIcon = children != null;
    const clearable = onClear !== undefined && typeof props.value === "string" && props.value !== "";
    const setRefs = react_2.default.useCallback((node) => {
        inputRef.current = node;
        if (typeof ref === "function")
            ref(node);
        else if (ref)
            ref.current = node;
    }, [ref]);
    const handleClear = () => {
        onClear?.();
        inputRef.current?.focus();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "ko:relative", children: [hasIcon && (0, jsx_runtime_1.jsx)("div", { className: "ko:absolute ko:left-4 ko:top-1/2 ko:-translate-y-1/2", children: children }), (0, jsx_runtime_1.jsx)(react_1.Input, { ...props, ref: setRefs, className: (0, utilities_1.twMerge)(InputVariants({ variant: hasIcon ? "icon" : "default", clearable })) }), clearable && ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleClear, "aria-label": clearLabel, className: "ko:absolute ko:right-4 ko:top-1/2 ko:-translate-y-1/2 ko:flex ko:items-center ko:justify-center ko:rounded-full ko:p-1 ko:text-neutral ko:hover:bg-neutral/8 ko:focus-visible:outline-2 ko:focus-visible:outline-offset-2 ko:focus-visible:outline-primary", children: (0, jsx_runtime_1.jsx)(icon_1.Icon, { icon: js_1.mdiClose, decorative: true, size: "small" }) }))] }));
}
exports.Input = react_2.default.forwardRef(InputComponent);
